import { InputAdornment, TextField, useTheme } from '@mui/material';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

interface Props {
  value: string;
  onChange: (value: string) => void;
  autoFocus?: boolean;
}

export default function CatalogSearchBar({
  value,
  onChange,
  autoFocus,
}: Props) {
  const theme = useTheme();
  return (
    <TextField
      value={value}
      autoFocus={autoFocus}
      placeholder="Search items, brands, sizes…"
      fullWidth
      size="small"
      onChange={e => onChange(e.target.value)}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchRoundedIcon
                sx={{
                  fontSize: 'body1.fontSize',
                  color: theme.palette.text.disabled,
                }}
              />
            </InputAdornment>
          ),
        },
      }}
      sx={{
        '& .MuiOutlinedInput-root': {
          borderRadius: '10px',
          fontSize: 'body2.fontSize',
        },
      }}
    />
  );
}
